export const EVENTS = {
  modal_show: 'Event Template Modal Show',
  template_previewed: 'Event Template Previewed',
  template_selected: 'Event Template Selected',
  event_created_with_template: 'Event Created With Template',
};
